import { BaseEntityDtoAny } from "@/common/ts/entity";

import EntityAffiliationInfoDisplay from "../../Entity/EntityAffiliation/EntityAffiliationInfoDisplay";
import { defaultTableCellContentOfChipProps } from "./TableCellContentOfChip";

const defaultDisplayProps = {
  tenant: false,
  departments: true,
  locations: true,
};

interface Props {
  entity: Nil<BaseEntityDtoAny>;
  displayProps?: Partial<typeof defaultDisplayProps>;
}

export default function TableCellContentOfAffiliation({ entity, displayProps }: Props) {
  const displayPropsComputed = {
    ...defaultDisplayProps,
    ...displayProps,
  };

  return (
    <EntityAffiliationInfoDisplay
      variant='compact'
      entity={entity}
      tenantId={undefined}
      chipProps={defaultTableCellContentOfChipProps}
      displayProps={displayPropsComputed}
    />
  );
}
